export default "__VITE_ASSET__702270fb__"